export const CarouselModelMockJson = {
  titleText: 'Popular Resorts',
  subTitleText: 'Marriott',
  eyebrow: 'Eyebrow',
  noOfCards: 3,
  ctaLabel: 'Test link',
  ctaLink: 'https://www.marriott.com',
  ctaType: 'tertiaryLink',
  cardTypes: 'cardlayered',
  cardCount: 6,
  openInaNewTab: true,
  totalNumberOfCards: ['card-0', 'card-1', 'card-2', 'card-3', 'card-4', 'card-5'],
  trackingProperties: {
    clickTrack: false,
    impressionTrack: false,
    impressionCount: false,
    enableScrollingBehavior: true,
  },
  styleclass: '',
  cqItems: {
    styleclass: 'standard',
    componentId: 'cardcarousel123',
    TrackingProperties: {
      clickTrack: false,
      impressionTrack: false,
      impressionCount: false,
      enableScrollingBehavior: true,
    },
    enableSpecialEffects: false,
    eyebrow: 'Eyebrow',
    cardCount: '6',
    enableLoadingAnimation: false,
    cardTypes: 'cardlayered',
    noOfCards: 3,
    enableTabletBreakpoint: false,
    ctaLabel: 'Text Link',
    subHeaderText: 'Lorem Ipsum',
    cqItems: {
      'card-5': {
        ':items': {
          cardlayered_copy: {
            TrackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: null,
              clickTrack: false,
              impressionTrack: false,
              location: null,
              trackingContentPosition: null,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: null,
              trackingOfferType: null,
            },
            eyebrow: 'Eyebrow',
            headerTag: 'h3',
            icon: 'facebook',
            impressionTrack: 'false',
            cardLayeredVariations: 'square',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            badgeIcon: 'special-rates/aaa',
            imgAltText: 'Sunrise over the clouds',
            clickTrack: 'false',
            fileReferenceImage:
              '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            header: 'Lorem Ipsum Dolor Sit Amet',
            fontSize: 't-subtitle-l',
            dynamicMedia: {
              altText: 'Sunrise over the clouds',
              assetPath: 'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502',
              dynamic: true,
              renditions: [
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=365&fit=constrain',
                  mediaValue: '992px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=344&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=332&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            },
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            ctaLink: 'https://www.marriott.com',
            badgeText: 'Badge Text',
            openInNewTab: true,
          },
        },
        allowedComponents: {
          components: [
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-5/mi-aem-common-spa/components/content/cardlayered',
              title: 'Card Layered',
            },
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-5/mi-aem-common-spa/components/content/cardvertical',
              title: 'Card Vertical',
            },
          ],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['cardlayered_copy'],
        columnClassNames: {
          cardlayered_copy: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'card-0': {
        ':items': {
          cardlayered: {
            TrackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: null,
              clickTrack: false,
              impressionTrack: false,
              location: null,
              trackingContentPosition: null,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: null,
              trackingOfferType: null,
            },
            eyebrow: 'Eyebrow',
            headerTag: 'h3',
            icon: 'facebook',
            impressionTrack: 'false',
            cardLayeredVariations: 'square',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            badgeIcon: 'special-rates/aaa',
            imgAltText: 'Sunrise over the clouds',
            clickTrack: 'false',
            fileReferenceImage:
              '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            header: 'Lorem Ipsum Dolor Sit Amet',
            fontSize: 't-subtitle-l',
            dynamicMedia: {
              altText: 'Sunrise over the clouds',
              assetPath: 'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502',
              dynamic: true,
              renditions: [
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=365&fit=constrain',
                  mediaValue: '992px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=344&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=332&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            },
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            ctaLink: 'https://www.marriott.com',
            badgeText: 'Badge Text',
            openInNewTab: true,
          },
        },
        allowedComponents: {
          components: [
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-0/mi-aem-common-spa/components/content/cardlayered',
              title: 'Card Layered',
            },
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-0/mi-aem-common-spa/components/content/cardvertical',
              title: 'Card Vertical',
            },
          ],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['cardlayered'],
        columnClassNames: {
          cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'card-4': {
        ':items': {
          cardlayered_copy: {
            TrackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: null,
              clickTrack: false,
              impressionTrack: false,
              location: null,
              trackingContentPosition: null,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: null,
              trackingOfferType: null,
            },
            eyebrow: 'Eyebrow',
            headerTag: 'h3',
            icon: 'facebook',
            impressionTrack: 'false',
            cardLayeredVariations: 'square',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            badgeIcon: 'special-rates/aaa',
            imgAltText: 'Sunrise over the clouds',
            clickTrack: 'false',
            fileReferenceImage:
              '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            header: 'Lorem Ipsum Dolor Sit Amet',
            fontSize: 't-subtitle-l',
            dynamicMedia: {
              altText: 'Sunrise over the clouds',
              assetPath: 'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502',
              dynamic: true,
              renditions: [
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=365&fit=constrain',
                  mediaValue: '992px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=344&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=332&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            },
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            ctaLink: 'https://www.marriott.com',
            badgeText: 'Badge Text',
            openInNewTab: true,
          },
        },
        allowedComponents: {
          components: [
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-4/mi-aem-common-spa/components/content/cardlayered',
              title: 'Card Layered',
            },
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-4/mi-aem-common-spa/components/content/cardvertical',
              title: 'Card Vertical',
            },
          ],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['cardlayered_copy'],
        columnClassNames: {
          cardlayered_copy: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'card-3': {
        ':items': {
          cardlayered_copy: {
            TrackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: null,
              clickTrack: false,
              impressionTrack: false,
              location: null,
              trackingContentPosition: null,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: null,
              trackingOfferType: null,
            },
            eyebrow: 'Eyebrow',
            headerTag: 'h3',
            icon: 'facebook',
            impressionTrack: 'false',
            cardLayeredVariations: 'square',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            badgeIcon: 'special-rates/aaa',
            imgAltText: 'Sunrise over the clouds',
            clickTrack: 'false',
            fileReferenceImage:
              '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            header: 'Lorem Ipsum Dolor Sit Amet',
            fontSize: 't-subtitle-l',
            dynamicMedia: {
              altText: 'Sunrise over the clouds',
              assetPath: 'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502',
              dynamic: true,
              renditions: [
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=365&fit=constrain',
                  mediaValue: '992px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=344&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=332&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            },
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            ctaLink: 'https://www.marriott.com',
            badgeText: 'Badge Text',
            openInNewTab: true,
          },
        },
        allowedComponents: {
          components: [
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-3/mi-aem-common-spa/components/content/cardlayered',
              title: 'Card Layered',
            },
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-3/mi-aem-common-spa/components/content/cardvertical',
              title: 'Card Vertical',
            },
          ],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['cardlayered_copy'],
        columnClassNames: {
          cardlayered_copy: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'card-2': {
        ':items': {
          cardlayered_copy: {
            TrackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: null,
              clickTrack: false,
              impressionTrack: false,
              location: null,
              trackingContentPosition: null,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: null,
              trackingOfferType: null,
            },
            eyebrow: 'Eyebrow',
            headerTag: 'h3',
            icon: 'facebook',
            impressionTrack: 'false',
            cardLayeredVariations: 'square',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            badgeIcon: 'special-rates/aaa',
            imgAltText: 'Sunrise over the clouds',
            clickTrack: 'false',
            fileReferenceImage:
              '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            header: 'Lorem Ipsum Dolor Sit Amet',
            fontSize: 't-subtitle-l',
            dynamicMedia: {
              altText: 'Sunrise over the clouds',
              assetPath: 'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502',
              dynamic: true,
              renditions: [
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=365&fit=constrain',
                  mediaValue: '992px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=344&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=332&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            },
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            ctaLink: 'https://www.marriott.com',
            badgeText: 'Badge Text',
            openInNewTab: true,
          },
        },
        allowedComponents: {
          components: [
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-2/mi-aem-common-spa/components/content/cardlayered',
              title: 'Card Layered',
            },
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-2/mi-aem-common-spa/components/content/cardvertical',
              title: 'Card Vertical',
            },
          ],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['cardlayered_copy'],
        columnClassNames: {
          cardlayered_copy: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'card-1': {
        ':items': {
          cardlayered_copy: {
            TrackingProperties: {
              atCCeVar48: null,
              additionalTrackingVariables: null,
              trackingDescription: null,
              clickTrack: false,
              impressionTrack: false,
              location: null,
              trackingContentPosition: null,
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: null,
              trackingOfferType: null,
            },
            eyebrow: 'Eyebrow',
            headerTag: 'h3',
            icon: 'facebook',
            impressionTrack: 'false',
            cardLayeredVariations: 'square',
            ':type': 'mi-aem-common-spa/components/content/cardlayered',
            badgeIcon: 'special-rates/aaa',
            imgAltText: 'Sunrise over the clouds',
            clickTrack: 'false',
            fileReferenceImage:
              '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            header: 'Lorem Ipsum Dolor Sit Amet',
            fontSize: 't-subtitle-l',
            dynamicMedia: {
              altText: 'Sunrise over the clouds',
              assetPath: 'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502',
              dynamic: true,
              renditions: [
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=365&fit=constrain',
                  mediaValue: '992px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=344&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'min-width',
                  height: 0,
                },
                {
                  renditionPath:
                    'https://s7d1.scene7.com/is/image/marriotts7stage/bonvoy-gettyimages-1041814538-24502:Square?wid=332&fit=constrain',
                  mediaValue: '576px',
                  width: 0,
                  dynamic: true,
                  damPath:
                    '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
                  mediaQuery: 'max-width',
                  height: 0,
                },
              ],
              damPath:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1041814538-24502.jpg',
            },
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            ctaLink: 'https://www.marriott.com',
            badgeText: 'Badge Text',
            openInNewTab: true,
          },
        },
        allowedComponents: {
          components: [
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-1/mi-aem-common-spa/components/content/cardlayered',
              title: 'Card Layered',
            },
            {
              path: '/content/mi-aem-common-spa/us/en/carrdcarousel/jcr:content/root/responsivegrid/cardcarouselcontainer/card-1/mi-aem-common-spa/components/content/cardvertical',
              title: 'Card Vertical',
            },
          ],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['cardlayered_copy'],
        columnClassNames: {
          cardlayered_copy: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
    },
    ctaType: 'tertiaryLink',
    ':type': 'mi-aem-common-spa/components/content/cardcarouselcontainer',
    openInaNewTab: true,
    ':itemsOrder': ['card-0', 'card-1', 'card-2', 'card-3', 'card-4', 'card-5'],
    headerText: 'Popular Resorts',
    totalNumberOfCards: ['card-0', 'card-1', 'card-2', 'card-3', 'card-4', 'card-5'],
    ctaLink: 'https://www.marriott.com',
    items: [],
    enableClickTrack: true,
    allowedComponents: [
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/wcm/foundation/components/responsivegrid',
        title: 'Layout Container',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/accordion',
        title: 'Accordion',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/accordioncontainer',
        title: 'Accordion Container',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/bannerlayered',
        title: 'Banner Layered',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/brandribbon',
        title: 'Brand Ribbon',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/breadcrumb',
        title: 'Breadcrumb',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/button',
        title: 'Button',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardcarouselcontainer',
        title: 'Card Carousel Container',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardhorizontalfeature',
        title: 'Card Horizontal Feature',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardhorizontalmini',
        title: 'Card Horizontal Mini-Standard',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlayered',
        title: 'Card Layered',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlinks',
        title: 'Card Links',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardvertical',
        title: 'Card Vertical',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/carousel',
        title: 'Carousel',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cobrandcardhorizontalflexible',
        title: 'Cobrand-Card Horizontal Flexible',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/container',
        title: 'Container',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/contentfragment',
        title: 'Content Fragment',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/contentfragmentlist',
        title: 'Content Fragment List',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/download',
        title: 'Download',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/embed',
        title: 'Embed',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/experiencefragment',
        title: 'Experience Fragment',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/herobanner',
        title: 'Common Hero Banner',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/hotelgallerytitle',
        title: 'Hotel Gallery Title',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/iconblock',
        title: 'Icon Block',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/image',
        title: 'Image',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/list',
        title: 'List',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/pdfviewer',
        title: 'PDF Viewer',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/progressbar',
        title: 'Progress Bar',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/separator',
        title: 'Separator',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/common/staticwrapper',
        title: 'Static Wrapper',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/tabs',
        title: 'Tabs',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/teaser',
        title: 'Teaser',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/text',
        title: 'Text',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/title',
        title: 'Title',
      },
    ],
    id: 'cardcarouselresorts-1725612474697',
  },
  componentId: 'testCarousel',
  pagePath: '',
  itemPath: '',
  wcmMode: 'Edit',
  isAuthorMode: false,
  noOfCardsTablet: 1,
  variation: 'standard',
  maxResortsCount: 10,
  hotelType: 'Resorts',
  activities: '[Golf, Resorts]',
  amenities: '[Gym, Swimming pool]',
  regions: '[APEC, NA]',
  destinationMetaData: {
    country: 'USA',
    city: 'Texas',
    latitude: '',
    placeId: 'ChIJSTKCCzZwQIYRPN4IGI8c6xY',
    countryCode: 'US',
    destinationName: 'Texas, USA',
    isStateEnabled: false,
    isCountryEnabled: false,
    stateCode: 'TX',
    state: 'Texas',
    radius: null,
    isPOI: false,
    longitude: '',
  },
  id: 'cardcarouselresorts-1725612474697',
};
